// Animations

// Toggle Greenhouse application
// This script toggles the visibility of the application form when the button is clicked.
// It uses a smooth height transition to show or hide the form.
// The script also ensures that the form is hidden when not in use, improving accessibility and user experience.

document.addEventListener('DOMContentLoaded', function () {
	const toggleButtons = document.querySelectorAll('.toggle-application');
	const wrapper = document.querySelector('#greenhouse-application-wrapper');

	if (!toggleButtons.length || !wrapper) return;

	const duration = 400; // match your transition duration

	// Add event listener to each toggle button
	toggleButtons.forEach(toggleButton => {
		toggleButton.addEventListener('click', function (e) {
			e.preventDefault();
			
		const isOpen = !wrapper.hasAttribute('hidden');

		if (isOpen) {
			// CLOSE
			wrapper.style.height = wrapper.scrollHeight + 'px';
			wrapper.classList.add('is-collapsing');

			requestAnimationFrame(() => {
				wrapper.style.height = '0px';
				wrapper.classList.remove('is-visible');

				setTimeout(() => {
					wrapper.setAttribute('hidden', '');
					wrapper.style.removeProperty('height');
					wrapper.classList.remove('is-collapsing');
				}, duration);
			});

				// Update all button texts
				toggleButtons.forEach(btn => {
					btn.textContent = 'Apply Now';
				});
		} else {
			// OPEN
			wrapper.removeAttribute('hidden');
			wrapper.style.height = '0px';

			requestAnimationFrame(() => {
				wrapper.classList.add('is-visible');
				wrapper.style.height = wrapper.scrollHeight + 'px';

				setTimeout(() => {
					wrapper.style.removeProperty('height');
						
						// Scroll to the form after it opens
						setTimeout(() => {
							wrapper.scrollIntoView({ 
								behavior: 'smooth', 
								block: 'start' 
							});
						}, 100);
				}, duration);
			});

				// Update all button texts
				toggleButtons.forEach(btn => {
					btn.textContent = 'Hide Application';
				});
		}
		});
	});
});


// Toggle Key Features
if (window.innerWidth <= 768) {
	document.addEventListener("DOMContentLoaded", function () {
		const features = document.querySelectorAll('.key-features');

		features.forEach(section => {
			const toggle = section.querySelector('p');
			const content = section.querySelector('div');

			if (toggle && content) {
				toggle.addEventListener('click', () => {
					section.classList.toggle('open');
				});
			}
		});
	});
}
